import { AfterViewChecked, AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { User } from './_models';
import { AlertDialog, AlertService, DialogType, MessageSeverity } from './_services/shared/alert.service';
import { DialogService } from './_services/shared/dialog.service';
import { AuthenticationService } from './_services/user/authentication/authentication.service';
import { LocalStoreManagerService } from './_services/user/authentication/local-store-manager.service';
import { UserSearchService } from './_services/user/user-search/user-search.service';
import { LoadingService } from './_services/shared/loading.service';
import { bufferTime, delay, distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Dialog } from '@angular/cdk/dialog';
import { LoadingComponent } from './_components/shared/loading/loading.component';
import { Subject } from 'rxjs';
import { SnackbarService } from './_services/shared/snackbar.service';
import { IrwinSearchService } from './_services/incident/irwin/irwin-search.service';
import { CollaboratorsFacadeService } from './_services/user/collaborators-facade.service';

@Component({
    selector: "wfdss-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent implements OnDestroy, OnInit{
  title = 'ui-wfdss-nextgen';
  currentUser: User;
  private loggedIn: boolean;
  searchTerms: string;
  private _destroying = new Subject<void>()
  private destroying$ = this._destroying.asObservable()
  public userHasElevatedRoles: boolean = true 

  /**  
   * @description controls when the loading spinner displays, via the loading service, which is updated from loading interceptors.*/
  private loading: boolean
  /**  
   * @description component reference to control creation/destruction of loading spinner.*/
   private loadingDialogRef: MatDialogRef<LoadingComponent>;

  constructor(private DialogService: DialogService, public alertService: AlertService,
              private loadingDialog: MatDialog,
              private irwin: IrwinSearchService,
              private iconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private snackBarService: SnackbarService,
              private loadingService: LoadingService,
              public collaboratorsFacadeSvc: CollaboratorsFacadeService,
              public authenticationService: AuthenticationService, private userSearchService: UserSearchService, private localStorageManager: LocalStoreManagerService) {}
  ngOnInit() {
    this.iconRegistry.addSvgIcon('incident_watched', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/wfdss/visibility_on.svg'));
    this.iconRegistry.addSvgIcon('incident_unwatched', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/wfdss/visibility_off.svg'));
    this.iconRegistry.addSvgIcon('csv_download', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/wfdss/download_csv.svg'));
    this.iconRegistry.addSvgIcon('incident_create', this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/wfdss/wfdss_logo_only_bw.svg'));
    // This sub clears out the collaborators services when an irwin incident is de-selected. Collaborators list is repopulated elsewhere.
    this.irwin.selectedIncident.pipe(takeUntil(this.destroying$)).subscribe((irwinInc)=>{
      if(!irwinInc){
        this.collaboratorsFacadeSvc.setCollaborators(null)
      }
    })
    // this.loggedIn = this.authenticationService.isLoggedIn;
     this.listenToLoading()
      setTimeout(() => {
      if (this.loggedIn) {
      }
    }, 2000);
    this.alertService.getDialogEvent().pipe(takeUntil(this.destroying$)).subscribe(alert => this.showDialog(alert));
    this.authenticationService.getLoginStatusEvent().pipe(takeUntil(this.destroying$)).subscribe(isLoggedIn => {
      this.loggedIn = isLoggedIn;
      if (this.loggedIn) {
        this.userSearchService.searchAllUsers();
      }

      setTimeout(() => {
        if (!this.loggedIn) {
          this.alertService.showMessage('Session Ended!', '', MessageSeverity.default);
        }
      }, 500);
    });
    this.authenticationService.loggedInUserIsElevated$.pipe(takeUntil(this.destroying$)).subscribe((userIsElevated)=>{
      this.userHasElevatedRoles = userIsElevated
    })
    this.loadingService.loadingMaxTimeout$.pipe(takeUntil(this.destroying$)).subscribe(()=>{})

		this.snackBarService.errorBuffer$.pipe(takeUntil(this.destroying$)).subscribe((groupedErrors) => {
			this.snackBarService.openDetailedErrorSnackbar(groupedErrors)
		})
    this.authenticationService.appComponentLoginStatusPolling().pipe(takeUntil(this.destroying$)).subscribe()   
  }
  listenToLoading(){
    this.loadingService._loading.pipe(
      takeUntil(this.destroying$),
      delay(0),
      distinctUntilChanged()
    ).subscribe((loading)=>{
      this.loading = loading
      if(loading){
        this.loadingDialogRef = this.loadingDialog.open(LoadingComponent, {
          panelClass: 'transparent',
          disableClose: true
        });
        this.loadingService.setSpinnerStatus(false);
      } else {
        this.loadingDialogRef?.close()
        this.loadingService.setSpinnerStatus(true);
      }
    })
  }
  showDialog(dialog: AlertDialog) {
    var okButtonText = dialog.okLabel || 'OK';
    var cancelButtonText = dialog.cancelLabel || 'Cancel';

		switch (dialog.type) {
			case DialogType.alert:
				this.DialogService.openAlertDialog(dialog.message)
				break
			case DialogType.confirm:
				this.DialogService.openConfirmDialog(dialog.message, okButtonText, cancelButtonText)
					.afterClosed()
					.pipe(takeUntil(this.destroying$))
					.subscribe((decision) => {
						if (decision === true) {
							dialog.okCallback()
						} else {
							if (dialog.cancelCallback) {
								dialog.cancelCallback()
							}
						}
					})

				break
			case DialogType.prompt:
				//Dont need any values passed from confirmation box currently, but I'll leave this here in case we do.
				// this.DialogService.openConfirmDialog(dialog.message,okButtonText,cancelButtonText).afterClosed().subscribe(decision => {
				//   if (decision === true) {
				//     dialog.okCallback();
				//   }
				//   else
				//   {
				//     if (dialog.cancelCallback)
				//     dialog.cancelCallback();
				//   }
				// });

				break
		}
	}
  ngOnDestroy(): void {
    this._destroying.unsubscribe()
    this._destroying.complete()
  }
}
